import React, { useEffect } from 'react';
import Header from '../../headerone/Main';
import Bredcom from '../../Bredcom/Main';
import DMVDetails from '../mendepartmentdetails/MotorVehicles';

function DMV() {
  useEffect(() => {
    document.getElementById("title").innerHTML = "Motor Vehicles || State of GTS";
  }, []);

  return (
    <>
      {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

      <div className="page-wrapper">
        <Bredcom 
          subtitle="home"
          title="Motor Vehicles"
          subtitledown="Department of Motor Vehicles"
        />
        <DMVDetails />
      </div>
    </>
  );
}

export default DMV;
